import type { RouteRecordRaw } from 'vue-router';

export const academicsRoutes: RouteRecordRaw = {
    path: 'academics',
    components: {
        default: () => import('@/layouts/modules/academics/AcademicsLayout.vue'),
        sidebar: () => import('@/layouts/modules/academics/AcademicAside.vue')
    },
    children: [
        {
            path: 'curriculum-level-item',
            name: 'curriculumLevelItem',
            component: () => import('@/views/modules/academics/global/curriculum/CurriculumLevelItemView.vue'),
        },
        {
            path: 'curriculum-levels',
            name: 'curriculumLevels',
            component: () => import('@/views/modules/academics/global/curriculum/CurriculumLevelsView.vue'),
        },
        {
            path: 'curriculum-sections',
            name: 'curriculumSections',
            component: () => import('@/views/modules/academics/global/curriculum/CurriculumLevelSectionsView.vue'),
        },
        {
            path: 'curriculum',
            name: 'curriculum',
            component: () => import('@/views/modules/academics/global/curriculum/CurriculumView.vue'),
        },
        {
            path: 'academic-years',
            name: 'academicYears',
            component: () => import('@/views/modules/academics/global/AcademicYearsView.vue'),
        },
        {
            path: 'terms',
            name: 'terms',
            component: () => import('@/views/modules/academics/global/TermsView.vue'),
        },
        {
            path: 'subjects',
            name: 'subjects',
            component: () => import('@/views/modules/academics/global/subjects/SubjectsView.vue'),
        },
        {
            path: 'subject-types',
            name: 'subjectTypes',
            component: () => import('@/views/modules/academics/global/subjects/SubjectTypesView.vue'),
        },
        {
            path: 'group-types',
            name: 'groupType',
            component: () => import('@/views/modules/academics/global/group-types/GroupTypeView.vue'),
        },
        {
            path: 'group-type-subjects',
            name: 'groupTypeSubjects',
            component: () => import('@/views/modules/academics/global/group-types/GroupTypeSubjectsView.vue'),
        },
        {
            path: 'curriculum-subjects',
            name: 'curriculumSubjects',
            component: () => import('@/views/modules/academics/global/subjects/CurriculumSubjectsView.vue'),
        },
        {
            path: 'curriculum-level-subjects',
            name: 'curriculumLevelSubjects',
            component: () => import('@/views/modules/academics/global/subjects/CurriculumLevelSubjectsView.vue'),
        },
        {
            path: 'curriculum-level-items-subjects',
            name: 'curriculumLevelItemsSubjects',
            component: () => import('@/views/modules/academics/global/subjects/CurriculumLevelItemSubjectsView.vue'),
        },
        {
            path: 'curriculum-level-sections-subjects',
            name: 'curriculumLevelSectionsSubjects',
            component: () => import('@/views/modules/academics/global/subjects/CurriculumLevelSectionSubjectsView.vue'),
        },
        {
            path: 'curriculum-level-section-data',
            name: 'curriculumLevelSectionData',
            component: () => import('@/views/modules/academics/global/curriculum/CurriculumLevelSectionDataView.vue'),
            children: [
                {
                    path: 'create',
                    name: 'createCurriculumLevelSectionData',
                    component: () => import('@/components/modules/academics/global/curriculum/curriculum-level-section-data/CurriculumLevelSectionDataCreateUpdateModal.vue'),
                }
            ],
        },
        {
            path: 'level-prefix',
            name: 'levelPrefix',
            component: () => import('@/views/modules/academics/global/level-managment/LevelPrefixView.vue'),
        },
        {
            path: 'levels',
            name: 'levels',
            component: () => import('@/views/modules/academics/global/level-managment/LevelsView.vue'),
        },
        // School Academic Routes
        {
            path: 'school',
            children: [
                {
                    path: 'levels',
                    name: 'schoolLevels',
                    component: () => import('@/views/modules/academics/school/SchoolLevelsView.vue'),
                },
                {
                    path: 'curriculums',
                    name: 'schoolCurriculums',
                    component: () => import('@/views/modules/academics/school/SchoolCurriculumsView.vue'),
                },
                {
                    path: 'academic-years',
                    name: 'schoolAcademicYears',
                    component: () => import('@/views/modules/academics/school/SchoolAcademicYearsView.vue'),
                },
                {
                    path: 'academic-year-curriculums',
                    name: 'schoolAcademicYearCurriculums',
                    component: () => import('@/views/modules/academics/school/SchoolAcademicYearCurriculumsView.vue'),
                },
                {
                    path: 'terms',
                    name: 'schoolTerms',
                    component: () => import('@/views/modules/academics/school/SchoolTermsView.vue'),
                },
                {
                    path: 'curriculum-level-section-data',
                    name: 'schoolSectionData',
                    component: () => import('@/views/modules/academics/school/SchoolCurriculumLevelSectionDataView.vue')
                },
                {
                    path: 'subjects',
                    name: 'schoolSubjects',
                    component: () => import('@/views/modules/academics/school/SchoolSubjectsView.vue'),
                }
            ]
        }
    ]
};